import {ActionType} from 'redux-promise-middleware';
import {
    DESTINATION_LOAD_DATA,
    DESTINATION_LOAD_EVENTS,
    DESTINATION_UPDATE,
    DESTINATION_RESET,
    DESTINATION_GET_AIRPORT_STRUCTURED_DATA,
} from './destination-actions';
import {ROUTER_DATA_LOAD_FULFILLED} from 'router/router-actions';

export const initialState = () => ({
    isPending: false,
    data: {},
    airportStructuredData: [],
    airportLowestDailyRate: 0,
    error: null,
});

export default function destination(state = initialState(), {type, payload}) {
    switch (type) {
        case `${DESTINATION_LOAD_DATA}_${ActionType.Pending}`: {
            return {
                ...state,
                isPending: true,
                error: null,
            };
        }

        case `${DESTINATION_LOAD_DATA}_${ActionType.Fulfilled}`: {
            return {
                ...state,
                isPending: false,
                data: {
                    ...state.data,
                    ...payload.data.data,
                },
            };
        }

        case `${DESTINATION_LOAD_DATA}_${ActionType.Rejected}`: {
            return {
                ...state,
                error: 'Could not load destination data.',
            };
        }

        case `${DESTINATION_LOAD_EVENTS}_${ActionType.Pending}`: {
            return {
                ...state,
                isPending: true,
                error: null,
            };
        }

        case `${DESTINATION_LOAD_EVENTS}_${ActionType.Fulfilled}`: {
            return {
                ...state,
                isPending: false,
                data: {
                    ...state.data,
                    events: payload.data.data.results,
                },
            };
        }

        case `${DESTINATION_LOAD_EVENTS}_${ActionType.Rejected}`: {
            return {
                ...state,
                error: 'Could not load events.',
            };
        }

        case DESTINATION_UPDATE: {
            return {
                ...state,
                data: {
                    ...state.data,
                    ...payload,
                },
            };
        }

        case DESTINATION_RESET: {
            return initialState();
        }

        case ROUTER_DATA_LOAD_FULFILLED: {
            const {destination: cleanedDestinationState} = payload;

            if (cleanedDestinationState) {
                return cleanedDestinationState;
            } else {
                return state;
            }
        }

        case `${DESTINATION_GET_AIRPORT_STRUCTURED_DATA}_${ActionType.Fulfilled}`: {
            // strip out all unnecessary data
            const responseData = payload.data.data.results;
            const airportLowestDailyRate = Math.min(
                ...responseData.map(
                    facility => facility.airport.lowest_daily_rate
                )
            );
            const airportStructuredData = responseData.reduce(
                (firstSixReviewedSpots, spotData) => {
                    if (
                        firstSixReviewedSpots.length < 6 &&
                        spotData.rating_info.number_of_ratings > 9
                    ) {
                        const {
                            id,
                            logos,
                            title,
                            airport: {lowest_daily_rate: lowestDailyRate},
                            street_address, // eslint-disable-line camelcase
                            city,
                            state: spotState,
                            zipcode,
                            rating_info, // eslint-disable-line camelcase
                        } = spotData;

                        firstSixReviewedSpots.push({
                            facility: {
                                id,
                                logos,
                                title,
                                lowestDailyRate,
                                street_address, // eslint-disable-line camelcase
                                city,
                                state: spotState,
                                zipcode,
                                rating_info, // eslint-disable-line camelcase
                            },
                        });
                    }

                    return firstSixReviewedSpots;
                },
                []
            );

            return {
                ...state,
                airportStructuredData,
                airportLowestDailyRate,
            };
        }

        default:
            return state;
    }
}
